module.exports = __webpack_public_path__ + "static/media/CHANGELOG.e683409f.bin";